import React, { FC, useCallback } from 'react';
import styles from './ReviewStarBar.module.scss';
import StarIcon from '@z-components/static/images/stars/star-11.svg';
import Button from '@z-components/atoms/Button';

interface Props {
  starNumber: number;
  feedbackCount: number;
  totalFeedbackCount: number;
  onClickSingleCounter?: (rate: number) => void;
  isShowCounter?: boolean;
}
const PERCENTILE = 100;
const ReviewStarBar: FC<Props> = ({
  starNumber,
  feedbackCount,
  totalFeedbackCount,
  isShowCounter = false,
  onClickSingleCounter,
}) => {
  const reviewPercentile = Math.floor((feedbackCount / totalFeedbackCount) * PERCENTILE);

  const reviewBar = {
    width: `${reviewPercentile}%`,
  };

  const onClickCounter = useCallback(
    (rate: number) => {
      if (onClickSingleCounter) {
        onClickSingleCounter(rate);
      }
    },
    [onClickSingleCounter]
  );

  return (
    <div className={styles['review-star-bar-container']}>
      <div className={styles['star']}>
        <StarIcon />
      </div>
      {starNumber}
      <div className={styles['review-percentile-container']}>
        <div className={styles['review-bar']} style={reviewBar}></div>
      </div>
      {isShowCounter && (
        <div className={styles['review-number-container']}>
          {feedbackCount > 0 ? (
            // eslint-disable-next-line react/jsx-no-bind
            <Button className="z-btn-blue-text" onClick={() => onClickCounter(starNumber)}>
              ({feedbackCount})
            </Button>
          ) : (
            <div className={styles['review-number']}>({feedbackCount})</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewStarBar;
